import React, { useState, useEffect } from 'react';
import { comments } from '../services/api';
import Comment from './Comment';
import '../styles/CommentList.css';

const CommentList = ({ recipeId, currentUser }) => {
  const [commentList, setCommentList] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);

  useEffect(() => {
    fetchComments();
  }, [recipeId]);

  const fetchComments = async () => {
    try {
      const response = await comments.getAll(recipeId);
      setCommentList(response.data);
    } catch (error) {
      console.error('Fetch comments error:', error);
    } finally {
      setFetchLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!currentUser) {
      alert('Jelentkezz be a kommenteléshez!');
      return;
    }

    if (!newComment.trim()) {
      alert('A komment nem lehet üres');
      return;
    }

    setLoading(true);
    try {
      const response = await comments.create(recipeId, newComment.trim());
      setCommentList([response.data, ...commentList]);
      setNewComment('');
    } catch (error) {
      console.error('Create comment error:', error);
      alert('Hiba a komment mentésekor');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = (updatedComment) => {
    setCommentList(commentList.map(c =>
      c._id === updatedComment._id ? updatedComment : c
    ));
  };

  const handleDelete = (commentId) => {
    setCommentList(commentList.filter(c => c._id !== commentId));
  };

  if (fetchLoading) {
    return <div className="comments-section"><p>Kommentek betöltése...</p></div>;
  }

  return (
    <div className="comments-section">
      <h3>Hozzászólások ({commentList.length})</h3>

      {/* Comment Form */}
      {currentUser ? (
        <form onSubmit={handleSubmit} className="comment-form">
          <textarea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Írd meg a véleményed..."
            maxLength={1000}
            rows={3}
            className="comment-textarea"
          />
          <div className="comment-form-footer">
            <span className="char-count">
              {newComment.length} / 1000
            </span>
            <button
              type="submit"
              disabled={loading || !newComment.trim()}
              className="btn btn-primary"
            >
              {loading ? 'Küldés...' : 'Komment küldése'}
            </button>
          </div>
        </form>
      ) : (
        <div className="comment-login-prompt">
          <p>Jelentkezz be a kommenteléshez!</p>
          <a href="/login" className="btn btn-primary">Bejelentkezés</a>
        </div>
      )}

      {/* Comments List */}
      <div className="comments-list">
        {commentList.length > 0 ? (
          commentList.map(comment => (
            <Comment
              key={comment._id}
              comment={comment}
              currentUserId={currentUser?._id}
              isAdmin={currentUser?.role === 'admin'}
              onUpdate={handleUpdate}
              onDelete={handleDelete}
            />
          ))
        ) : (
          <p className="no-comments">Még nincs hozzászólás. Légy te az első!</p>
        )}
      </div>
    </div>
  );
};

export default CommentList;
